import React, { useEffect, useState } from "react";
import Spinner from "../../images/spinner.gif";
import { Redirect } from "react-router-dom";

const Calculating = () => {
  const [timeLeft, setTimeLeft] = useState(4);
  useEffect(() => {
    if (timeLeft === 0) {
      setTimeLeft(null);
    }
    if (!timeLeft) return;

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 500);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
  }, [[timeLeft]]);
  if (timeLeft === 0) {
    return <Redirect to="/results/" />;
  }
  return (
    <section id="calculating">
      <div className="container">
        <div className="top">
          <img src={Spinner} alt="" />
          <h2>Calculating...</h2>
        </div>
      </div>
    </section>
  );
};

export default Calculating;
